import { createSlice } from "@reduxjs/toolkit";
import { getNextHour } from "../../utils/timestampUtils";

export interface TimerState {
  nextChangeTime: string;
}

const initialState: TimerState = {
  nextChangeTime: getNextHour().toJSDate().toString(),
}

export const timerSlice = createSlice({
  name: 'timer',
  initialState,
  reducers: {
    setNewTimer: (state) => {
      state.nextChangeTime = getNextHour().toJSDate().toString();
    },
  },
});

export const { setNewTimer } = timerSlice.actions;

export default timerSlice.reducer;